import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetEcshopTradesHistoryService } from "@/features/accounts/ecshop/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetEcshopTradesHistoryResponseModel } from "@/features/accounts/ecshop/services/get-trades-history-model";

export const useGetEcshopTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getEcshopTradesHistoryService = new GetEcshopTradesHistoryService();

  // EC取込履歴取得
  const getEcshopTradesHistory = async (
    accountGroupId: string,
    ecshopAccountId: string,
    ecshopId: string,
    offset?: string,
  ): Promise<GetEcshopTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getEcshopTradesHistoryService.getEcshopTradesHistory({
        account_group_id: accountGroupId,
        ecshop_account_id: ecshopAccountId,
        ecshop_id: ecshopId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getEcshopTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getEcshopTradesHistory: errorHandledAsync(getEcshopTradesHistory, setError),
  };
};
